import { render, staticRenderFns } from "./connect-privacy.vue?vue&type=template&id=9727c8c4&scoped=true&"
import script from "./connect-privacy.vue?vue&type=script&lang=js&"
export * from "./connect-privacy.vue?vue&type=script&lang=js&"
import style0 from "./connect-privacy.vue?vue&type=style&index=0&id=9727c8c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9727c8c4",
  null
  
)

export default component.exports